import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { ProductsBlockView } from './ProductsBlockView';

export const Products = Node.create({
    name: 'products',

    group: 'block',

    defining: true,

    isolating: true,

    addAttributes() {
        return {
            isPopular: {
                default: false,
            },
            latest: {
                default: true,
            },
            isHotDeal: {
                default: false,
            },
            isBuilderChoice: {
                default: false,
            },
            isProPicks: {
                default: false,
            },
            isTrendingNow: {
                default: false,
            },
            mostOrdered: {
                default: false,
            },
            productCount: {
                default: 5,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
                getAttrs: (dom) => {
                    return {
                        isPopular: dom.getAttribute('data-isPopular') || false,
                        latest: dom.getAttribute('data-latest') || true,
                        isHotDeal: dom.getAttribute('data-isHotDeal') || false,
                        isBuilderChoice: dom.getAttribute('data-isBuilderChoice') || false,
                        isProPicks: dom.getAttribute('data-isProPicks') || false,
                        isTrendingNow: dom.getAttribute('data-isTrendingNow') || false,
                        mostOrdered: dom.getAttribute('data-mostOrdered') || false,
                        productCount: dom.getAttribute('data-productCount') || 5,
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        const {
            isPopular,
            latest,
            isHotDeal,
            isBuilderChoice,
            isProPicks,
            isTrendingNow,
            mostOrdered,
            productCount,
        } = HTMLAttributes;

        return [
            'div',
            {
                'data-type': 'products',
                'data-isPopular': isPopular,
                'data-latest': latest,
                'data-isHotDeal': isHotDeal,
                'data-isBuilderChoice': isBuilderChoice,
                'data-isProPicks': isProPicks,
                'data-isTrendingNow': isTrendingNow,
                'data-mostOrdered': mostOrdered,
                'data-productCount': productCount,
                class: 'products-block',
            },
            'Products Block'
        ];
    },

    addCommands() {
        return {
            setProducts:
                (options) =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: {
                                isPopular: options?.isPopular || false,
                                latest: options?.latest || true,
                                isHotDeal: options?.isHotDeal || false,
                                isBuilderChoice: options?.isBuilderChoice || false,
                                isProPicks: options?.isProPicks || false,
                                isTrendingNow: options?.isTrendingNow || false,
                                mostOrdered: options?.mostOrdered || false,
                                productCount: options?.productCount || 5,
                            },
                        });
                    },
            updateProducts:
                (options) =>
                    ({ commands }) => {
                        return commands.updateAttributes(this.name, options);
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(ProductsBlockView);
    },
});